<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';
    import { targetComments } from '../../Diff/diffStore.js';
    import {fade} from 'svelte/transition';
    import BranchPath from '../../Branch/BranchPath.svelte';
    import {elementDetails, elementInstance, standaloneEdit, editable} from '../workspacesStore.js';
    import TagDisplay from '../../Tag/TagDisplay.svelte';
    import Thumbnail from '../../common/Media/Thumbnail.svelte';
    import ElementTypeDisplay from '../../Element/ElementTypeDisplay.svelte';
    import ContextualText from './ContextualText.svelte';
    import ContextualFieldLink from '../../ContextualFieldLink.svelte';
    import {sgettext} from '../../../i18n.js';
    import {onMount} from 'svelte';
    import {PaginationNav} from 'svelte-paginate';
    import Section from '../../common/Section.svelte';
    import AssetExecutionDetails from '../../Element/AssetExecutionDetails.svelte';
    import InspectionLocation from '../../Element/InspectionLocation.svelte';
    import StatusBadge from '../../common/StatusBadge.svelte';

    export let count = null;
    export let details = $elementDetails;
    export let showVersions = true;
    export let workspaceReadOnly = false;
    export let diffView = false;
    export let leftSide = false;
    export let contextualReadOnly = false;
    export let templateStatus = "";
    export let templateVersionNumber = 0;
    export let showContextualFields = true;


    import {
        approvalInfo
      } from '../../Diff/diffStore.js';

    $: hasWorkSequence = Boolean($elementInstance?.worksequenceId);

    let elementVersionId = 0;
    let action = 'Editing';
    let container;
    let narrow = false;

    export let currentPage = 1;
    export let pageSize = 1;

    export let changePage = () => {};

    if (changePage) {
        changePage({page: 1});
    }

    $: if($targetComments) {
       currentPage = 1;
    }

    $:paginatedItems = $targetComments?.length ?
                       $targetComments.slice((currentPage - 1) * pageSize,(currentPage - 1) * pageSize + pageSize): [];

    $:showContextualPhoto = true

    let isContextualDiff = $approvalInfo?.contextualDiff || false;

    $: isAIESInspectedQualityElement = $approvalInfo.isAssetIntegrity && details.type == "QUALITY" && details.ev_inspection_element == "Asset Integrity";
    $: interactionType = details?.inspection_location_data?.location_type == "Area" ? 
                        sgettext("$$BROAD_AREA$$") + " - " + sgettext("$$QUESTIONS_DISPLAY_RAISING_DEFECT$$") :
                        sgettext("$$INSPECTION_POINT$$") + " - " + sgettext("$$QUESTIONS_DISPLAY_ELEMENT$$")


    function initResponsive() {
        if (container) {
            const rect = container.getBoundingClientRect();
            if (rect.width < 650) {
                narrow = true;
            } else {
                narrow = false;
            }
        }
    }

    function setShowContextualPhoto(showPhoto){
        showContextualPhoto=showPhoto
    }

    onMount(() => {
        initResponsive();
    });
</script>

<svelte:window on:resize={initResponsive} />

{#if details}
  <div class="title" transition:fade|local>
    {#if !$standaloneEdit && contextualReadOnly && approvalInfo.diffType == 'CONTEXTUAL'}
      <span class="float-right">
        <ContextualText>* {sgettext('$$CONTEXTUAL_UPDATES$$')}</ContextualText>
        <br />
        {#if templateStatus}
          {sgettext('$$ACTIVITY_VERSION$$')}: {sgettext(templateStatus)}
        {/if}
      </span>
    {/if}
    <h3 pk={details.elementId}>
      {#if $standaloneEdit}
        {details.name}
        {#if details.suffix}
          <ContextualText>{details.suffix}</ContextualText>
        {/if}
      {/if}
      <!-- NOTE: Count badges of number of times element or element version is used, need not to be displayed in combined contextual diff view -->
      {#if count != null && !isContextualDiff}
        <small style="float: right;">
          {#if typeof count == 'number'}
            <span
              title={sgettext('$$NUMBER_TIMES_ELEMENT_USED$$')}
              class="badge badge-secondary badge-pill"
            >
              {count}
            </span>
          {:else}
            <span
              title={`${sgettext('$$NUMBER_TIMES_ELEMENT_VERSION_USED$$')}${
                count.source
              } to ${count.target}`}
              class="badge badge-secondary badge-pill"
            >
              {count.source} <i class="fa fa5-arrow-right" />
              {count.target}
            </span>
          {/if}
        </small>
      {/if}
    </h3>

    {#if isContextualDiff}
    <div style="display: flex; align-items: center; margin-bottom: 10px;">
        <h5 style="font-weight: bold; margin: 0;">
            {leftSide ? sgettext("$$ORIGINAL_TEMPLATE$$") : sgettext("$$THIS_TEMPLATE$$")} - {`${sgettext('V')}${templateVersionNumber}`}
        </h5>
        <div>
            <StatusBadge status={templateStatus} />
        </div>
    </div>
    {/if}

    {#if !$standaloneEdit && isContextualDiff}
      {#if details.role}
        <div class="text-secondary mb-3">
          <div>
            {sgettext('$$ROLE$$')}: {details.role}
          </div>
          <div>
            {sgettext('$$SEQUENCE$$')}: {details.work_sequence}
          </div>
          <div>
            {sgettext('$$ELEMENT_NUMBER$$')}: {details.step + 1}
            <!-- step is zero-indexed -->
          </div>
        </div>
      {/if}
    {/if}

    {#if showVersions}
      <label style="font-weight: normal;" transition:fade|local
        >{`${sgettext('$$VERSION$$')} ${details.version} (${
          details.status_display[0]
        }${details.status_display.substring(1).toLowerCase()})`}</label
      >
    {:else if !isContextualDiff}
      <label transition:fade|local
        >{` ${sgettext('$$ID_1$$')} ${details.elementId}, ${sgettext('$$VERSION$$')} ${
          details.version
        }`}</label
      >
    {/if}
  </div>

  {#if isContextualDiff}
    <div style="text-align: right; color: gray; margin: 10px 0;">
        <span>{sgettext("$$ELEMENT$$")}: {details.elementId}, {sgettext("$$VERSION$$")} {details.version}</span>
    </div>
  {/if}

  {#if details.comment && diffView && leftSide}
    <div class="diff_view_comment">
      <p class="comments-label">{sgettext('$$COMMENTS$$')}</p>
      <p class="comments-details">{details.comment}</p>
      <div class="diff_view_comment-arrow" />
    </div>
  {:else if !details.comment && diffView && leftSide}
    <div style="height:110px; width:100%; clear:both;" />
  {/if}

  {#if $targetComments?.length && diffView && !leftSide}
    <div class="diff_view_comment">
      <p class="comments-label">{sgettext('$$COMMENTS$$')}</p>
      <span class="custom-nav">
        <PaginationNav
          totalItems={$targetComments.length}
          pageSize={1}
          {currentPage}
          limit={1}
          showStepOptions={true}
          on:setPage={(e) => {
            currentPage = e.detail.page;
          }}
        >
          <span slot="number">
            {currentPage} / {$targetComments.length}
          </span>
        </PaginationNav>
      </span>
      <ul class="items">
        {#each paginatedItems as item}
          <li class="item">
            {sgettext('$$VERSION$$')}
            {item.element_version_number} - {item.comment}
          </li>
        {/each}
      </ul>
      <div class="diff_view_comment-arrow" />
    </div>
  {:else if !$targetComments?.length && diffView && !leftSide}
    <div style="height:110px; width:100%; clear:both;" />
  {/if}

  <div
    bind:this={container}
    class="details-row"
    transition:fade|local
  >
    {#if showContextualFields}
      <div class="wrapper">
        {#each [details] as model}
          <Section title={sgettext('$$STRATEGY$$')}>
            <AssetExecutionDetails {model} showEditLinks={false} />
          </Section>
        {/each}
      </div>
    {/if}

    {#if isAIESInspectedQualityElement && isContextualDiff}
      <div class="wrapper">
        {#each [details?.inspection_location_data] as inspectionLocation}
          <Section title={sgettext('$$INSPECTION_LOCATION$$')}>
            <InspectionLocation {inspectionLocation} />
          </Section>
        {/each}
      </div>
    {/if}

    <div class="row">
      <div class:col-md-6={!narrow} class:col-12={narrow}>
        <table>
          <tbody>
            <tr>
              <th>{sgettext('$$TITLE$$')}</th>
              <td colspan="3" style="font-weight: bold;">
                {#if diffView}
                  <a
                    href={`${PATH_PREFIX}/sw/elements_database/${details.elementId}`}
                    style="text-decoration: none;">{details.name}</a
                  >
                {:else}
                  {details.name}
                {/if}
              </td>
            </tr>
            {#if !$standaloneEdit && showContextualFields}
              <tr>
                <th class="contextual">{sgettext('$$TITLE_SUFFIX$$')}</th>
                <td colspan="3">
                  <ContextualText
                    >{details.suffix ? details.suffix : ''}</ContextualText
                  >
                  {#if !workspaceReadOnly && !details.element_from_apm && $editable && !diffView}<ContextualFieldLink
                      focus="suffix"
                      value={details.suffix}
                    />{/if}
                </td>
              </tr>
            {/if}

            {#if isAIESInspectedQualityElement && isContextualDiff}
                <tr>
                <th class="contextual">{sgettext('$$INTERACTION_TYPE$$')}</th>
                <td colspan="3">
                    <ContextualText>{interactionType}</ContextualText>
                </td>
                </tr>
            {/if}
            
            <tr>
              <th>{sgettext('$$LOCATION$$')}</th>
              <td colspan="3">
                <BranchPath path={details.location} />
              </td>
            </tr>
            <tr>
              <th style="width: 25%;">{sgettext('$$TYPE$$')}</th>
              <td style="width: 25%;">
                <ElementTypeDisplay type={details.type} />
              </td>
              <td />
              <td />
            </tr>
            {#if details?.ev_inspection_element == 'Asset Integrity' && details.type === 'QUALITY'}
              <tr>
                <th>{sgettext('$$INSPECTION$$')}</th>
                <td colspan="3" style="font-weight: bold;">
                  {details?.ev_inspection_element}
                </td>
              </tr>
              {#if !$standaloneEdit && showContextualFields}
                <tr>
                  <th class="contextual">{sgettext('$$DAMAGE_GROUP$$')}</th>
                  <td colspan="3">
                    <ContextualText
                      >{details.damage_group_name
                        ? details.damage_group_name
                        : ''}</ContextualText
                    >
                    {#if !workspaceReadOnly && details.inspection_location__type != 'Area' && $editable && !diffView}<ContextualFieldLink
                        focus="suffix"
                        value={details.damage_group_name}
                      />{/if}
                  </td>
                </tr>
              {/if}
            {/if}
            <tr>
              <th style="width: 10%;">{sgettext('$$TIME$$')}</th>
              <td style="width: 25%;">
                {details.time}
                {sgettext('$$SECS$$')}
              </td>
              {#if !$standaloneEdit && showContextualFields}
                <th class="contextual">{sgettext('$$CONTEXTUAL_TIME$$')}</th>
                <td style="width: 25%;">
                  {#if details.contextual_time}
                    <ContextualText
                      >{`${details.contextual_time} ${sgettext(
                        '$$SECS$$'
                      )}`}</ContextualText
                    >
                  {/if}
                  {#if !workspaceReadOnly && $editable && !diffView}<ContextualFieldLink
                      focus="contextual_time"
                      value={details.contextual_time}
                    />{/if}
                </td>
              {/if}
            </tr>
            {#if !$standaloneEdit && showContextualFields}
              <tr>
                <th class="contextual">{sgettext('$$FLOC_REFLOC$$')}</th>
                <td colspan="3">
                  <ContextualText
                    >{details.floc ? details.floc : ''}</ContextualText
                  >
                </td>
              </tr>
            {/if}
            <tr>
              <th>{sgettext('$$TAGS$$')}</th>
              <td colspan="3">
                <TagDisplay tags={details.tags} />
              </td>
            </tr>
            <tr>
              <th>{sgettext('$$COMPETENCIES$$')}</th>
              <td colspan="3">
                <TagDisplay tags={details.competencies} key="name" />
              </td>
            </tr>
            {#if details.type === 'QUALITY'}
              <tr>
                <th>{sgettext('$$REPORTING_GROUPS$$')}</th>
                <td colspan="3">
                  <TagDisplay tags={details.reportingGroups} key="name" />
                </td>
              </tr>
            {/if}
          </tbody>
        </table>
      </div>
      <div class:col-md-6={!narrow} class:col-12={narrow}>
        <a
          on:click={() => setShowContextualPhoto(false)}
          style={showContextualPhoto && details.contextual_photo
            ? 'color: #B7B9BB'
            : 'font-weight: bold'}
        >
          {sgettext('$$MAIN_PHOTO$$')}
        </a>
        {#if details.contextual_photo && details.contextual_photo.url}
          |
          <a
            on:click={() => setShowContextualPhoto(true)}
            style={!showContextualPhoto
              ? 'color: #B7B9BB'
              : 'font-weight: bold'}
          >
            {sgettext('$$CONTEXTUAL_PHOTO$$')}
          </a>
        {/if}
        {#if !showContextualPhoto || !details.contextual_photo}
          {#if details.element_slide && details.element_slide.url}
            <div class="media" transition:fade|local>
              <Thumbnail
                width="540px"
                height="100%"
                url={details.element_slide.url}
                media={details.element_slide.url}
                name={sgettext('$$ELEMENT_MAIN_PHOTO$$')}
                type={details.element_slide.type}
              />
            </div>
          {/if}
        {/if}
        {#if showContextualPhoto && details.contextual_photo && details.contextual_photo.url}
          <Thumbnail
            width="100%"
            height="auto"
            url={details.contextual_photo.url}
            media={details.contextual_photo.url}
            name="contextual photo"
            type={details.contextual_photo.type}
            linkLabel={sgettext('$$VIEW_CONTEXTUAL_PHOTO$$')}
          />
        {/if}
      </div>
    </div>
  </div>
{/if}

<style>
  table {
    width: 100%;
  }

  th {
    vertical-align: top;
  }

  th,
  td {
    padding: 0.75rem 0;
  }

  @media (max-width: 1600px) {
    .details-row {
      grid-template-columns: 1fr;
    }
  }

  .title {
    margin-bottom: 15px;
  }
  .title h3 {
    color: var(--gray-dark);
  }

  .title label {
    color: #454545;
  }

  span[slot='linkLabel'] {
    font-size: 16px;
  }

  .media {
    overflow-y: hidden;
    max-height: 360px;
  }

  .diff_view_comment {
    position: relative;
    background: #f2f4f5;
    border: 5px solid #f2f4f5;
    border-radius: 10px 10px 0px 10px;
    margin-bottom: 15px;
  }

  .diff_view_comment-arrow {
    position: absolute;
    right: -5px;
    bottom: -25px;
    border-left: 21px solid transparent;
    border-top: 20px solid #f2f4f5;
    padding-bottom: 5px;
  }

  .comments-label {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    margin-left: 10px;
    margin-top: 10px;
  }

  .comments-details {
    margin-left: 10px;
    font-size: 16px;
    font-weight: normal;
  }

  .custom-nav :global(.pagination-nav) {
    display: flex;
    background: #f2f4f5;
    border-radius: 3px;
    float: right;
    box-shadow: none;
    margin-top: -50px;
  }

  .custom-nav :global(.option.number) {
    display: none;
  }

  .custom-nav :global(.option.number.active) {
    display: inline;
  }

  .items {
    list-style-type: none;
    margin-left: -30px;
  }

  .wrapper {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    width: 100%;
    margin-bottom: 15px;
  }
</style>
